import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';
import PasekBoczny from './components/PasekBoczny';
import ChronionaTrasa from './components/ChronionaTrasa';
import { DostawcaLogowania, useLogowanie } from './context/KontekstLogowania';

import Logowanie from './pages/Logowanie';
import PanelGlowny from './pages/PanelGlowny';
import SrodkiTrwale from './pages/SrodkiTrwale';
import DodajSrodek from './pages/DodajSrodek';
import SzczegolySrodka from './pages/SzczegolySrodka';
import EdytujSrodek from './pages/EdytujSrodek';
import Przesuniecia from './pages/Przesuniecia';
import Raporty from './pages/Raporty';
import Logi from './pages/Logi';
import PanelAdministratora from './pages/PanelAdministratora';
import ZapomnianeHaslo from './pages/ZapomnianeHaslo';
import ResetHasla from './pages/ResetHasla';
import PierwszaZmianaHasla from './pages/PierwszaZmianaHasla';
import Amortyzacja from './pages/Amortyzacja';

function Uklad() {
  const { uzytkownik } = useLogowanie();
  return <>
    <PasekBoczny />
    <Box sx={{ ml: uzytkownik ? '238px' : 0, p: uzytkownik ? { xs:2, md:3 } : 0, minHeight:'100vh' }}>
      <Routes>
        <Route path="/logowanie" element={<Logowanie/>}/>
        <Route path="/zapomniane-haslo" element={<ZapomnianeHaslo/>}/>
        <Route path="/reset-hasla" element={<ResetHasla/>}/>
        <Route path="/pierwsza-zmiana-hasla" element={<PierwszaZmianaHasla/>}/>
        <Route path="/panel-glowny" element={<ChronionaTrasa><PanelGlowny/></ChronionaTrasa>}/>
        <Route path="/srodki-trwale" element={<ChronionaTrasa uprawnienie="ASSET_VIEW"><SrodkiTrwale/></ChronionaTrasa>}/>
        <Route path="/srodki-trwale/dodaj" element={<ChronionaTrasa uprawnienie="ASSET_CREATE"><DodajSrodek/></ChronionaTrasa>}/>
        <Route path="/srodki-trwale/:id/edytuj" element={<ChronionaTrasa uprawnienie="ASSET_EDIT"><EdytujSrodek/></ChronionaTrasa>}/>
        <Route path="/srodki-trwale/:id" element={<ChronionaTrasa uprawnienie="ASSET_VIEW"><SzczegolySrodka/></ChronionaTrasa>}/>
        <Route path="/przesuniecia" element={<ChronionaTrasa uprawnienie="ASSET_VIEW"><Przesuniecia/></ChronionaTrasa>}/>
        <Route path="/raporty" element={<ChronionaTrasa uprawnienie="REPORT_VIEW"><Raporty/></ChronionaTrasa>}/>
        <Route path="/amortyzacja" element={<ChronionaTrasa uprawnienie="DEPRECIATION_VIEW"><Amortyzacja/></ChronionaTrasa>}/>
        <Route path="/logi" element={<ChronionaTrasa uprawnienie="AUDIT_VIEW"><Logi/></ChronionaTrasa>}/>
        <Route path="/administracja" element={<ChronionaTrasa uprawnienie="ADMIN_PANEL"><PanelAdministratora/></ChronionaTrasa>}/>
        <Route path="/" element={<Navigate to={uzytkownik ? '/panel-glowny' : '/logowanie'} replace/>}/>
        <Route path="*" element={<Navigate to={uzytkownik ? '/panel-glowny' : '/logowanie'} replace/>}/>
      </Routes>
    </Box>
  </>;
}

export default function App() {
  return <DostawcaLogowania><Router><Uklad/></Router></DostawcaLogowania>;
}
